if (!customElements.get("section-quiz")) {
	customElements.define(
		"section-quiz",
		class SectionQuiz extends HTMLElement {
			constructor() {
				super();

				this.steps = [
					"gender",
					"age",
					"interests",
					"skinType",
					"goals",
					"specifics",
					"concerns",
					"subscribe",
				];

				this.quizForm = this.querySelector("form");
				this.navButtons();
			}

			connectedCallback() {
				this.quizForm?.addEventListener("submit", this.handleSubmit);
			}

			handleSubmit = (e) => {
				e.preventDefault();
				const formData = this.getFormData();
				const submitUrl = this.getAttribute("data-submit");
				const url = new URL(submitUrl, window.location.origin);
				url.searchParams.append("variant", new Date().getTime());

				Object.keys(formData).forEach((key) => {
					if (Array.isArray(formData[key])) {
						formData[key].forEach((value) =>
							url.searchParams.append(`${key}[]`, value),
						);
					} else {
						url.searchParams.append(key, formData[key]);
					}
				});

				window.location.href = url.toString();
			}

			navButtons() {
				this.querySelectorAll(".js-next").forEach((btn) => {
					btn.addEventListener("click", (e) => {
						e.preventDefault();
						const filteredSteps = this.getFilteredSteps();
						const currentSection = e.target.closest("section");
						const currentIndex = filteredSteps.findIndex(
							(step) => step === currentSection.id,
						);
						const id = currentSection.id;

						if (!this.validateInput(id)) {
							alert("Please select an option to proceed.");
							return;
						} else if(id === 'goals') {
							const goalsSelected = this.getFormData().goals || [];
							if (goalsSelected.length < 3) {
								alert("Please select at least 3 goal to proceed.");
								return;
							}
						}

						const nextSection = document.getElementById(
							filteredSteps[currentIndex + 1],
						);
						this.handleSectionToggle(currentSection, nextSection);
					});
				});

				this.querySelectorAll(".js-prev").forEach((btn) => {
					btn.addEventListener("click", (e) => {
						e.preventDefault();
						const filteredSteps = this.getFilteredSteps();
						const currentSection = e.target.closest("section");
						const currentIndex = filteredSteps.indexOf(currentSection.id);

						const prevSection = document.getElementById(
							filteredSteps[currentIndex - 1],
						);
						this.handleSectionToggle(currentSection, prevSection);
					});
				});
			}

			handleSectionToggle(currentSection, targetSection) {
				if (currentSection && targetSection) {
					currentSection.style.display = "none";
					targetSection.style.display = "block";
				}
			}

			getFormData() {
				const formData = new FormData(this.quizForm);
				const obj = Object.fromEntries(formData.entries());
				if (formData.getAll("goals").length) {
					obj.goals = formData.getAll("goals");
				}
				return obj;
			}

			getFilteredSteps() {
				const formData = this.getFormData(this.quizForm);
				const gender = formData.gender;
				const interests = formData.interests;
				return this.steps.filter((item) => {
					if (!interests) {
						return true;
					}

					if (item === "goals" || item === "skinType") {
						return interests !== "inner";
					} else if (item === "concerns" || item === "specifics") {
						if (gender === "male" && item === "specifics") {
							return false;
						}
						return interests !== "outer";
					}

					return true;
				});
			}

			getProperHandle(handle, country) {
				if (country === "nz" || country === "au") {
					return (
						quizProducts.find((item) => item.main_handle === handle)?.handle[
							country
						] || handle
					);
				}

				return handle;
			}

			validateInput(name) {
				const formData = this.getFormData(this.quizForm);
				return formData[name] !== undefined && formData[name] !== "";
			}
		},
	);
}
